import React, { useCallback, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import httpService from "../../../Service/httpService";
import StripeEmbedPaymentForm from "../Components/StripeEmbedPaymentForm";
import { getUser, getUserID } from "../../../Service/getLocalStorage";
import ApplyGiftCard from "../../ApplyGiftCard";
import { GiftCardPreview } from "../../../Service/giftCard";

const BuyMembership = ({ membershipData }: { membershipData: any }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [giftCardCode, setGiftCardCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getClientSecret = useCallback(
    async (appliedGiftCardCode?: string) => {
      const code = appliedGiftCardCode ?? giftCardCode;
      const params: Record<string, unknown> = {
        user_id: getUserID(),
        membership_id: membershipData?.membership_id,
        amount: membershipData?.amount,
        total_amount: membershipData?.total_amount,
        tax: membershipData?.tax,
        coupon_amount: membershipData?.coupon_amount,
        tax_amount: membershipData?.tax_amount,
        email: getUser()?.email,
        qty: 1,
      };

      // Gift card and promo coupon cannot be combined.
      if (code) {
        params.gift_card_code = code;
      } else if (membershipData?.coupon_id) {
        params.coupon_id = membershipData.coupon_id;
      }

      try {
        setIsLoading(true);
        const response: any = await httpService.post(
          "purchase-membership",
          params
        );
        if (response?.data?.clientSecret) {
          setClientSecret(response?.data?.clientSecret);
          window.removeEventListener("beforeunload", () => {});
        } else {
          const message = response?.data?.message || response?.data?.error;
          toast.error(
            Array.isArray(message)
              ? message.join(", ")
              : message || response?.message || "Something went wrong"
          );
        }
      } catch (err: any) {
        const message = err?.response?.data?.message || err?.response?.data?.error;
        toast.error(
          Array.isArray(message)
            ? message.join(", ")
            : message || err?.message || "Something went wrong"
        );
      } finally {
        setIsLoading(false);
      }
    },
    [giftCardCode, membershipData]
  );

  const handleGiftCardApplied = (code: string, _preview: GiftCardPreview | null) => {
    setGiftCardCode(code);
    setClientSecret("");
    if (getUserID()) {
      getClientSecret(code);
    }
  };

  useEffect(() => {
    getClientSecret();
  }, [membershipData]);

  return (
    <>
      {getUserID() && (
        <>
          <ApplyGiftCard
            checkoutType="membership"
            product={{
              membership_id: membershipData?.membership_id,
              amount: membershipData?.amount ?? membershipData?.total_amount,
            }}
            selectedCode={giftCardCode}
            onApplied={handleGiftCardApplied}
          />
          <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
            Applies to your first membership charge only. Renewals bill normally.
          </p>
        </>
      )}

      {clientSecret && <StripeEmbedPaymentForm clientSecret={clientSecret} />}
      {!clientSecret && isLoading && (
        <div className="w-full d-flex align-items-center justify-content-center py-5">
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default BuyMembership;
